/**
 * @generated SignedSource<<9e929fc3593aa2b2db45be126b8e6a3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RepositoryMilestonePageContentInternal$data = {
  readonly milestone: {
    readonly number: number;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"ToggleMilestoneState">;
  } | null | undefined;
  readonly name: string;
  readonly nameWithOwner: string;
  readonly owner: {
    readonly login: string;
  };
  readonly viewerCanPush: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryMilestoneInternal">;
  readonly " $fragmentType": "RepositoryMilestonePageContentInternal";
};
export type RepositoryMilestonePageContentInternal$key = {
  readonly " $data"?: RepositoryMilestonePageContentInternal$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryMilestonePageContentInternal">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "number",
  "variableName": "number"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "number"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "query"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RepositoryMilestonePageContentInternal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameWithOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanPush",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "login",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v0/*: any*/)
      ],
      "concreteType": "Milestone",
      "kind": "LinkedField",
      "name": "milestone",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ToggleMilestoneState"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "number",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        (v0/*: any*/),
        {
          "kind": "Variable",
          "name": "query",
          "variableName": "query"
        }
      ],
      "kind": "FragmentSpread",
      "name": "RepositoryMilestoneInternal"
    }
  ],
  "type": "Repository",
  "abstractKey": null
};
})();

(node as any).hash = "58e5aeb69d6ba59fed99f9bda52400ac";

export default node;
